import { render, staticRenderFns } from "./video_widget.vue?vue&type=template&id=71e41b98&scoped=true&lang=pug"
import script from "./video_widget.vue?vue&type=script&lang=js"
export * from "./video_widget.vue?vue&type=script&lang=js"
import style0 from "./video_widget.vue?vue&type=style&index=0&id=71e41b98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e41b98",
  null
  
)

export default component.exports